
<template>
  <v-container grid-list-lg>
    <v-layout wrap>
      <!-- <v-btn @click="dialogFormModule = true">Add Module</v-btn>
        <v-btn @click="dialogWebinar = true">Add Webinar</v-btn> -->
      <v-flex xs4>
        <v-layout row>
          <v-flex xs6>
            <v-menu v-model="uFormModal" :close-on-content-click="false" :nudge-right="40" lazy
              transition="scale-transition" offset-y full-width min-width="290px">
              <template v-slot:activator="{ on }">
                <v-text-field v-model="dateRange.start" label="Date Start" prepend-icon="event" readonly v-on="on">
                </v-text-field>
              </template>
              <v-date-picker v-model="dateRange.start" @input="uFormModal = false"></v-date-picker>
            </v-menu>
          </v-flex>
          <v-flex xs6>
            <v-menu v-model="uEndModal" :close-on-content-click="false" :nudge-right="40" lazy
              transition="scale-transition" offset-y full-width min-width="290px">
              <template v-slot:activator="{ on }">
                <v-text-field v-model="dateRange.end" label="Date End" prepend-icon="event" readonly v-on="on">
                </v-text-field>
              </template>
              <v-date-picker v-model="dateRange.end" @input="uEndModal = false"></v-date-picker>
            </v-menu>
          </v-flex>
        </v-layout>
        <v-btn @click="generateData('user')" :loading="onLoading">Generate Users</v-btn>
        <v-btn @click="generateData('assessment')" :loading="onLoading">Generate assessment</v-btn>
        <v-btn @click="generateData('certificate')" :loading="onLoading">Generate certificate</v-btn>
        <download-csv v-if="csvData.userData.length > 0" :data="csvData.userData" name="users.csv">
          <v-btn color="success">Download Users</v-btn>
        </download-csv>
        <download-csv v-if="csvData.assessData.length > 0" :data="csvData.assessData" name="assessment.csv">
          <v-btn color="success">Download assessment</v-btn>
        </download-csv>
        <download-csv v-if="csvData.certData.length > 0" :data="csvData.certData" name="certificate.csv">
          <v-btn color="success">Download certificate</v-btn>
        </download-csv>
      </v-flex>
      <!-- <v-flex xs4 v-for="(module, i) in modules" :key="i">
        <v-card hover @click.native="handleClick(module.id)">
          <v-card-media :src="module.image" height="200"> </v-card-media>

          <v-list two-line>
            <v-list-tile>
              <v-list-tile-content>
                <v-list-tile-title>
                  <strong>{{ module.title }}</strong>
                </v-list-tile-title>
                <v-list-tile-sub-title>
                  {{ module.description }}
                </v-list-tile-sub-title>
                <v-list-tile-sub-title>
                  <em>by {{ module.author }}</em>
                </v-list-tile-sub-title>
              </v-list-tile-content>
            </v-list-tile>
          </v-list>

          <v-card-text>
            <strong>CPD Points </strong>
            <v-avatar color="primary">
              <span class="white--text title">{{ module.cpd_points }}</span>
            </v-avatar>
          </v-card-text>
        </v-card>
      </v-flex> -->
    </v-layout>

    <v-dialog v-model="dialogFormModule" transition="dialog-bottom-transition" :overlay="false" scrollable>
      <add-module-form :apiUrl="apiUrl"></add-module-form>
    </v-dialog>

    <v-dialog v-model="dialogWebinar" persistent max-width="600px">
      <v-card>
        <v-card-title>
          <span class="headline">Webinar</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-flex>
              <v-col cols="12" sm="6" md="4">
                <v-text-field v-model="submitData.title" label="Title *" required></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="4">
                <v-text-field v-model="submitData.description" label="Description *"
                  hint="example of helper text only on focus" required></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="4">
                <v-text-field v-model="submitData.category" label="Category *" required></v-text-field>
              </v-col>
              <v-col cols="12" sm="6">
                <v-radio-group v-model="submitData.is_recorded">
                  <v-radio :key="0" label="Link" :value="0"></v-radio>
                  <v-radio :key="1" label="Recorded" :value="1"></v-radio>
                </v-radio-group>
              </v-col>
              <v-col cols="12" v-if="submitData.is_recorded === 0">
                <v-text-field label="Url*" v-model="submitData.url" required></v-text-field>
              </v-col>
              <v-col cols="12" v-if="submitData.is_recorded === 1">
                <v-flex xs12 class="text-xs-center text-sm-center text-md-center text-lg-center">
                  <v-text-field label="Select Video *" @click="pickFileVideo" v-model="videoName"
                    prepend-icon="attach_file"></v-text-field>
                  <input type="file" style="display: none" ref="video" accept="video/*" @change="onFilePickedVideo" />
                </v-flex>
              </v-col>
            </v-flex>
            <v-flex>
              <v-flex xs12 class="text-xs-center text-sm-center text-md-center text-lg-center">
                <img :src="imageUrl" height="150" v-if="imageUrl" />
                <v-text-field label="Select Image *" @click="pickFile" v-model="imageName" prepend-icon="attach_file">
                </v-text-field>
                <input type="file" style="display: none" ref="image" accept="image/*" @change="onFilePicked" />
              </v-flex>
            </v-flex>
          </v-container>
          <small>*indicates required field</small>
        </v-card-text>
        <div>
          <v-alert :value="this.hasError" type="error">
            Please complete fields.
          </v-alert>
        </div>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" :disabled="this.isSaving" text @click="dialogWebinar = false">Close</v-btn>
          <v-btn color="blue darken-1" :loading="this.isSaving" text @click="handleSubmitWebinar()">Submit</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
/* eslint-disable */
import axios from 'axios'
import AddModuleForm from '@/components/admin/module/addModuleForm'
import Vue from 'vue'
import JsonCSV from 'vue-json-csv'

Vue.component('downloadCsv', JsonCSV)
import config from '../../../configApi'
const apiUrl = config.apiUrl

export default {
  components: {
    AddModuleForm
  },
  created() {
    this.token = localStorage.getItem('token')
  },
  data() {
    return {
      onLoading: false,
      modules: [],
      submitData: {
        title: null,
        description: null,
        category: null,
        is_recorded: 0,
        url: null,
        image: null,
        video: null
      },
      errorMessage: null,
      hasError: false,
      dialogFormModule: false,
      token: null,
      dialogWebinar: false,
      csvData: {
        userData: [],
        certData: [],
        assessData: []
      },
      uFormModal: false,
      uEndModal: false,
      cStartModal: false,
      cEndModal: false,
      aStartModal: false,
      aEndModal: false,
      dateRange: {
        start: new Date().toISOString().substring(0, 10),
        end: new Date().toISOString().substring(0, 10),
      },
      title: 'Image Upload',
      imageName: '',
      imageUrl: '',
      imageFile: '',
      videoName: '',
      videoUrl: '',
      videoFile: '',
      isSaving: false,
    };
  },
  methods: {
    generateData(type) {
      let url = `${apiUrl}/generate/users`;
      let dataType = 'user';
      switch (type) {
        case 'assessment':
          url = `${apiUrl}/generate/assessment`;
          dataType = 'assessment'
          break;
        case 'certificate':
          url = `${apiUrl}/generate/certificate`;
          dataType = 'certificate'
          break;
        default:
          url = `${apiUrl}/generate/users`;

      }
      const params = {
        start: this.dateRange.start,
        end: this.dateRange.end,
      }
      axios.post(url, params).then((res) => {
        if (res.status == 200) {
          switch (dataType) {
            case 'assessment':
              this.csvData.assessData = res.data
              this.csvData.certData = []
              this.csvData.userData = []
              break;
            case 'certificate':
              this.csvData.certData = res.data
              this.csvData.assessData = []
              this.csvData.userData = []
              break;
            default:
              this.csvData.userData = res.data
              this.csvData.assessData = []
              this.csvData.certData = []

          }

        }
      }).catch((err) => console.log(err))
    },
    pickFile() {
      this.$refs.image.click();
    },
    pickFileVideo() {
      this.$refs.video.click();
    },
    onFilePicked(e) {
      const files = e.target.files;
      if (files[0] !== undefined) {
        this.imageName = files[0].name;
        if (this.imageName.lastIndexOf(".") <= 0) {
          return;
        }
        const fr = new FileReader();
        fr.readAsDataURL(files[0]);
        fr.addEventListener("load", () => {
          this.imageUrl = fr.result;
          this.imageFile = files[0]; // this is an image file that can be sent to server...
        });
      } else {
        this.imageName = "";
        this.imageFile = "";
        this.imageUrl = "";
      }
    },
    onFilePickedVideo(e) {
      const files = e.target.files;
      if (files[0] !== undefined) {
        this.videoName = files[0].name;
        if (this.videoName.lastIndexOf(".") <= 0) {
          return;
        }
        const fr = new FileReader();
        // fr.readAsDataURL(files[0]) // This reads a file and returns a Data URL referencing it. This is inefficient for large files as the file is loaded into memory as a whole before being processed
        fr.readAsArrayBuffer(files[0]); // This reads a file and returns an ArrayBuffer containing the input file 'chopped up in smaller pieces'. This works for very large files, too.
        fr.addEventListener("load", () => {

          // handle big file size of video
          let TYPED_ARRAY = new Uint8Array(fr.result);
          const STRING_CHAR = TYPED_ARRAY.reduce((data, byte) => {
            return data + String.fromCharCode(byte);
          }, '')
          let base64String = btoa(STRING_CHAR);
          base64String = 'data:video/mp4;base64,' + base64String

          this.videoUrl = base64String
          // old setting
          // this.videoUrl = fr.result
          this.videoFile = files[0]; // this is an image file that can be sent to server...
        });
      } else {
        this.videoName = "";
        this.videoFile = "";
        this.videoUrl = "";
      }
    },
    getModules() {
      axios.get(apiUrl + "/module").then((res) => {
        this.modules = res.data;
      });
    },
    handleSubmitWebinar() {
      const { title, description, category, url } = this.submitData;
      if (title && description && category) {
        this.hasError = false;
      } else {
        this.hasError = true;
        return;
      }
      if (this.submitData.is_recorded === 1) {
        this.submitData.url = null;
      } else {
        if (url) {
          this.hasError = false;
        } else {
          this.hasError = true;
          return;
        }
      }
      this.isSaving = true;
      let data = { file: this.imageUrl };
      axios.post(`${apiUrl}/upload`, data).then((res) => {
        if (res.status === 200) {
          if (this.submitData.is_recorded === 1) {
            let data2 = { file: this.videoUrl };
            axios
              .post(`${apiUrl}/uploadFile`, data2)
              .then((response) => {
                if (response.status === 200) {
                  this.submitData.image = res.data.url;
                  this.submitData.video = response.data.url;
                  axios
                    .post(`${apiUrl}/webinar`, this.submitData)
                    .then((res) => {
                      if (res.status === 201) {
                        this.dialogWebinar = false;
                        this.submitData.title = null;
                        this.submitData.category = null;
                        this.submitData.url = null;
                        this.submitData.description = null;
                        this.submitData.image = null;
                        this.submitData.video = null;
                        this.submitData.is_recorded = 0;
                        this.imageFile = "";
                        this.imageName = "";
                        this.imageUrl = "";
                        this.videoName = "";
                        this.videoUrl = "";
                        this.videoFile = "";
                        this.isSaving = false;
                      }
                    })
                    .catch((e) => {
                      this.isSaving = false;
                      console.log("error", e);
                    });
                }
              })
              .catch((error) => {
                console.log("error", error);
                this.isSaving = false;
              });
          } else {
            this.submitData.image = res.data.url;
            axios
              .post(`${apiUrl}/webinar`, this.submitData)
              .then((res) => {
                if (res.status === 201) {
                  this.dialogWebinar = false;
                  this.submitData.title = null;
                  this.submitData.category = null;
                  this.submitData.url = null;
                  this.submitData.description = null;
                  this.submitData.image = null;
                  this.submitData.is_recorded = 0;
                  this.imageFile = "";
                  this.imageName = "";
                  this.imageUrl = "";
                  this.isSaving = false;
                }
              })
              .catch((e) => {
                console.log("error", e);
              });
          }
        } else {
          console.log("Failed to upload");
          this.isSaving = false;
        }
      });
    },
    handleClick(moduleId) {
      this.$router.push("/admin/module/" + moduleId);
    },
    addToArray() {
      let obj = { question: "", answer: "" };
      this.multipleQuestions.push(obj);
    },
    removeToArray(index) {
      console.log(index);
      // this.$delete(this.multipleQuestions, index)
    },
    updateMultiQuestions(obj, index) {
      this.multipleQuestions[index] = obj;
    },
  },
  mounted() {
    this.getModules();
  },
  props: {
    apiUrl: {
      type: String,
    },
  }
};
</script>


// WEBPACK FOOTER //
// src/components/admin/index.vue